
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 85.619 47.779"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Path 93","d":"M0 7.167v33.445a7.166 7.166 0 007.167 7.167h66.5a7.166 7.166 0 007.167-7.167V7.167A7.166 7.166 0 0073.667 0h-66.5A7.166 7.166 0 000 7.167","fill":"#4e4d4d"}}),_c('path',{attrs:{"data-name":"Path 94","d":"M1.72 7.614V40.16a5.619 5.619 0 005.619 5.619H73.5a5.619 5.619 0 005.616-5.619V7.614A5.619 5.619 0 0073.5 1.995H7.339A5.619 5.619 0 001.72 7.614","fill":"#4d4d4d"}}),_c('path',{attrs:{"data-name":"Path 95","d":"M1.565 6.656v34.13a5.619 5.619 0 005.619 5.617H60.71V1.037H7.184a5.619 5.619 0 00-5.619 5.619","fill":"#4d4d4d"}}),_c('path',{attrs:{"data-name":"Path 96","d":"M85.619 15.488v17.9c0 .956-1.046 1.732-2.336 1.732h-3.894V13.756h3.894c1.29 0 2.336.776 2.336 1.732","fill":"#4e4d4d"}})])
          )
        }
      }
    